import { Flex, Spin } from 'antd';

/**
 * Full-width placeholder shown while a page's data is still being fetched.
 *
 * Every transient loading state inside one navigation should render this same
 * component: swapping between differently shaped placeholders reads as a
 * flicker even when the page never actually went blank (SKY-4581).
 */
export function BlankLoading() {
  return (
    <Flex className="w-full items-center justify-center p-12" data-testid="blank-loading">
      <Spin spinning={true}></Spin>
    </Flex>
  );
}
